import { z } from "zod";

/**
 * Wejście lookupu KW — trzy pola formularza (kod wydziału / numer / cyfra kontrolna).
 * Ten sam schemat waliduje wejście na backendzie i na froncie.
 */
export const KwLookupInputSchema = z.object({
  kodWydzialu: z.string().trim().toUpperCase().regex(/^[A-Z0-9]{4}$/),
  nrKw: z.string().trim().regex(/^\d{8}$/),
  cyfraK: z.string().trim().regex(/^\d$/),
});
export type KwLookupInput = z.infer<typeof KwLookupInputSchema>;

const KwDzialEntrySchema = z.object({
  label: z.string(),
  value: z.string(),
});

const KwDzialSchema = z.object({
  available: z.boolean(),
  empty: z.boolean(),
  entries: z.array(KwDzialEntrySchema),
});

const KwWlascicielSchema = z.object({
  typ: z.enum(["fizyczna", "prawna", "inna"]),
  nazwa: z.string(),
});

/**
 * Walidacja snapshotu KW zapisywanego do `projects.kw_data`. Kształt musi zgadzać
 * się z typem KwData (types/ksiega-wieczysta.types.ts).
 */
export const KwDataSchema = z.object({
  numer: z.string(),
  sad: z.string(),
  typNieruchomosci: z.string(),
  widok: z.string(),
  powierzchnia: z.string().nullable(),
  sposobKorzystania: z.string().nullable(),
  polozenie: z.string().nullable(),
  identyfikatoryDzialek: z.array(z.string()),
  miejscowosc: z.string().nullable(),
  ulica: z.string().nullable(),
  nrBudynku: z.string().nullable(),
  nrLokalu: z.string().nullable(),
  przeznaczenie: z.string().nullable(),
  pokoje: z.number().nullable(),
  kondygnacja: z.string().nullable(),
  pomieszczeniaPrzynalezne: z.string().nullable(),
  powierzchniaPrzynaleznychM2: z.number().nullable(),
  powierzchniaLokaluM2: z.number().nullable(),
  wlasciciele: z.array(KwWlascicielSchema),
  maObciazenia: z.boolean(),
  maHipoteke: z.boolean(),
  dzialy: z.object({
    IO: KwDzialSchema,
    ISp: KwDzialSchema,
    II: KwDzialSchema,
    III: KwDzialSchema,
    IV: KwDzialSchema,
  }),
  zrodloUrl: z.string(),
  // Brak tego pola w schemacie oznaczał, że `z.object` wycinał `pomieszczenia`
  // z każdego PATCH /v1/projects/:id — a backfill pokoi pomija wiersze tylko wtedy,
  // gdy tablica jest obecna, więc przy każdym przebiegu przepisywał wszystko od nowa.
  pomieszczenia: z
    .array(z.object({ nazwa: z.string(), liczba: z.number(), mieszkalne: z.boolean() }))
    .optional(),
  // Ustawiane przez anonymizeKw() przy zapisie. Opcjonalne, bo rekordy sprzed
  // wprowadzenia anonimizacji tego pola nie mają.
  personalDataOmitted: z.boolean().optional(),
});
